import React, { useEffect, useState } from "react";
import { getFirestore, setWithExpiry, getWithExpiry } from "../../config/firebase";
import logoWhatsapp from "../../assets/img/logoWhatsapp.png";
import "./whatsapp.scss";
import WhatsAppModal from "./WhatsAppModal";
import useFirestoreUpdate from "../../config/useFirestoreData";
import {
  buildWhatsAppSendUrl,
  getWhatsAppUrl,
  hasUtmInCurrentUrl,
  resolveUtmParams,
  saveUtmParams,
  whatsappConfig,
} from "../../config/whatsappConfig";
import { sendPostRequest } from "../../config/desol";

const WhatsAppFlotante = () => {
  // Eliminado: flag de visibilidad, ahora siempre visible
  const [whatsappIndividual, setWhatsappIndividual] = useState(null);

  // Procesar UTM parameters al cargar el componente
  useEffect(() => {
    saveUtmParams();
  }, []);

  useEffect(() => {
    const cargarDatosInformacion = async () => {
      // Intentar recuperar los datos de localStorage con expiración
      const datosLocales = getWithExpiry("hyundai-informacion");
      if (datosLocales) {
        // Buscar el documento "whatsapp" en los datos locales
        const whatsappDoc = datosLocales.find((doc) => doc.id === "whatsapp");
        if (whatsappDoc) {
          setWhatsappIndividual(whatsappDoc.url);
        }
      } else {
        // Si no hay datos en localStorage, hacer la llamada a Firestore
        const db = getFirestore();
        const vehicles = db.collection("hyundai-informacion");
        try {
          const querySnapshot = await vehicles.get();
          const datosCompletos = querySnapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }));

          // Buscar el documento "whatsapp" en los datos de Firestore
          const whatsappDoc = datosCompletos.find((doc) => doc.id === "whatsapp");
          if (whatsappDoc) {
            setWhatsappIndividual(whatsappDoc.url);
          }

          // Guardar los datos en localStorage con expiración
          setWithExpiry("hyundai-informacion", datosCompletos);
        } catch (error) {
          console.error("Error al obtener datos de Firestore: ", error);
        }
      }
    };
    cargarDatosInformacion();
  }, []);

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { updateData } = useFirestoreUpdate("consultas", "validaciones");

  const getWhatsAppUrlFromConfig = (brandKey = null) => {
    const utmParams = resolveUtmParams(brandKey);

    if (hasUtmInCurrentUrl() && utmParams.utm_source && whatsappConfig[utmParams.utm_source]) {
      return getWhatsAppUrl(utmParams);
    }

    return buildWhatsAppSendUrl(brandKey || "hyundai", utmParams);
  };

  const handleModalSubmit = async (values) => {
    setLoading(true);
    try {
      const pathname = window.location.pathname.toLowerCase();
      const slugMatch = pathname.match(/consultas\/(\w+)/);
      const slugBrand = slugMatch && slugMatch[1] ? slugMatch[1] : "";
      const brand = (values.marcaInteres || slugBrand || "").toLowerCase();
      const utmParams = resolveUtmParams(brand);
      const {
        utm_source,
        utm_medium,
        utm_campaign,
        utm_content,
        utm_term,
        utm_id,
        utm_brand,
      } = utmParams;

      await updateData({
        ...values,
        utm_source,
        utm_medium,
        utm_campaign,
        utm_term,
        utm_content,
        utm_id,
        utm_brand,
      });
      const campaignByBrand = {
        peugeot: "C12_PEUGEOT_LANDINGS",
        jeep: "C12_JEEP_LANDINGS",
        ram: "C12_JEEP_LANDINGS",
        ford: "C12_FORD_LANDINGS",
        fiat: "C12_FIAT_LANDINGS",
        hyundai: "C12_HYUNDAI_LANDINGS",
        gac: "C12_GAC_LANDINGS",
      };
      const resolvedCampaign = campaignByBrand[brand] || "C12_HYUNDAI_LANDINGS";

      // Preparar datos para Desol
      const capitalize = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : "");
      const brandLabel = capitalize(brand);

      const dataForDesol = {
        Apellido: values.nombre,
        Email: values.email,
        Telefono: values.celular,
        Canal: "WhatsApp",
        Motivo: `Consulta por WhatsApp - ${brandLabel}${utm_source ? ` - ${utm_source}` : ""}`,
        OrigenLead: `${process.env.REACT_APP_LANDING} - ${brandLabel}${utm_source ? ` - ${utm_source}` : ""}`,
        CommercialCampaign: utm_medium,
        Campaign: resolvedCampaign,
        Modelo_Pedido: `Consulta WhatsApp - ${brandLabel}`,
      };

      // Enviar a Desol
      try {
        await sendPostRequest(process.env.REACT_APP_DESOL_URL, dataForDesol);
        console.log("Datos enviados exitosamente a Desol");
      } catch (desolError) {
        console.error("Error al enviar a Desol:", desolError);
        // No bloqueamos el flujo si falla Desol, solo mostramos el error en consola
      }

      setOpen(false);

      const whatsappUrl = brand ? buildWhatsAppSendUrl(brand, utmParams) : getWhatsAppUrlFromConfig();

      // Console.log para verificar el link antes de redirigir
      console.log(`🚀 [WhatsApp Flotante] Redirigiendo a WhatsApp`);
      console.log(`🔗 Marca seleccionada: ${brand ? brand.toUpperCase() : "No especificada"}`);
      console.log(`📱 URL de WhatsApp que se usará:`, whatsappUrl);

      window.location.href = whatsappUrl;
    } catch (error) {
      console.error("Error al procesar el formulario:", error);
      alert("Ocurrió un error al guardar los datos. Intenta nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  // Siempre visible: ignoramos el flag mostrarWhatsapp

  return (
    <div className="whatsapp-container">
      <WhatsAppModal open={open} onClose={() => setOpen(false)} onSubmit={handleModalSubmit} loading={loading} />
      <button className="btn-whatsapp-flotante" onClick={() => setOpen(true)} disabled={loading}>
        <img src={logoWhatsapp} alt="whatsapp" />
      </button>
    </div>
  );
};
export default WhatsAppFlotante;

